import { BackNavigation, Button, Card, Loader, Typography } from 'src/components/common';
import cx from './createProgramListForm.module.scss';
import { InputField } from 'src/components/common/formFields';
import { Form, Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import React, { useRef, useState } from 'react';
import createProgramListFormValidationSchema from './createProgramListForm.validationSchema';
import { createProgramListFormInitialValue, CreateProgramListFormValues } from './createProgramListFormInitialValue';
import { componentSizeVariantsEnum } from 'src/constants';
import { UploadIcon } from 'src/components/common/common.icons';
import { Col, Row } from 'react-bootstrap';
import { openPopup } from 'src/store/common/common.slice';
import { TGetCompanyPresignedUrlActionRequest, TUploadCompanyProfilePictureResponse } from 'src/services/apiEndpoint.types.ts';
import handleExtension from 'src/utils/handleDocumentNameExtension/handleDocumentNameExtension';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { APIResponse } from 'src/services/base.api.service';
import { CompanyAPIService } from 'src/services/company.service';
import { httpRequest } from 'src/services/commonApis';
import { useGetIdentity } from 'src/hooks';
import SelectField from 'src/components/common/formFields/selectField/SelectField';
import { Industries } from 'src/constants/user.constants';
import { TSelectCardRadioButton } from 'src/components/common/formFields/selectCardRadio/SelectCardRadio';
import { enumToJson } from 'src/utils';
import { creatListProgram } from 'src/store/program/program.slice';
import { disablePastDate } from 'src/utils/DisablePastDate/disablePasteDate';
import MultiSelectField from 'src/components/common/formFields/multiSelectField/MultiSelectField';
import { ProgramAPIService } from 'src/services/program.service';
import imageCompresser from 'src/components/common/image-compresser/imageCompresser';
export default function CreateProgramListForm({ handleClose }: { handleClose: any }) {
    const dispatch = useAppDispatch();
    const loading: boolean = useAppSelector((store) => store.program.programLoading);

    const { getIdentities } = useGetIdentity();
    const uploadImageRef = useRef<HTMLInputElement>(null);
    const [bannerLoading, setBannerLoading] = useState<boolean>(false);

    const { loggedInUserId, loggedInCompanyId, loggedInUserType } = getIdentities();

    const userId = loggedInUserType === 'User' ? loggedInUserId : loggedInCompanyId;
    const programType = [
        { label: 'Govt. Programs', value: 'Govt. Programs', id: 'Govt. Programs' },
        { label: 'Corporate Programs', value: 'Corporate Programs', id: 'Corporate Programs' },
        { label: 'Incubators', value: 'Incubators', id: 'Incubators' },
        { label: 'E-Cells', value: 'E-Cells', id: 'E-Cells' }
    ]
    const industriesOptions: TSelectCardRadioButton[] = enumToJson({
        enumData: Industries
    });
    const openImageFileManager = async () => {
        if (uploadImageRef.current) {
            uploadImageRef.current.click();
        }
    };
    const handleUpload = async (e, setFieldValue) => {
        const file = e.target.files[0];
        if (!file?.type?.includes('image')) {
            dispatch(
                openPopup({
                    popupMessage: 'Please select valid image file',
                    popupType: 'error'
                })
            );
            return
        }
        setBannerLoading(true)
        if (file) {
            const compressedFile = await imageCompresser(file, 0.7);
            const fileName = handleExtension(compressedFile?.name?.replaceAll(/\s+/g, ''))
            const reader = new FileReader();
            reader.readAsArrayBuffer(compressedFile);
            reader.onload = async () => {
                try {
                    const data = reader.result;
                    const uploadProfilePicturePayload: TGetCompanyPresignedUrlActionRequest = {
                        id: userId,
                        data,
                        showPopup: false
                    };
                    const response: any = await new ProgramAPIService().getPresignedUrl({ companyId: uploadProfilePicturePayload.id, fileName })
                    if (response?.data?.data?.signedUrl) {
                        const res: APIResponse<TUploadCompanyProfilePictureResponse> | any =
                            await new CompanyAPIService().uploadCompanyProfilePicture({
                                presignedUrl: response?.data?.data?.signedUrl,
                                data,
                                includeAuthorizationHeaders: false
                            });
                        if (res.status === 200) {
                            const data: any = await new ProgramAPIService().getPresignedUrl({ companyId: uploadProfilePicturePayload.id, fileName })
                            if (data?.data?.data?.key) {
                                // setFieldValue('banner', { url: data?.data?.key, height: '500px', width: '100%' })
                                setFieldValue('banner', { url: data?.data?.data?.key })
                            } else {
                                dispatch(
                                    openPopup({
                                        popupMessage: 'something went wrong',
                                        popupType: 'error'
                                    })
                                );
                            }
                            setBannerLoading(false)
                        } else {
                            dispatch(
                                openPopup({
                                    popupMessage: res?.message || 'something went wrong',
                                    popupType: 'error'
                                })
                            );
                        }
                    } else {
                        setBannerLoading(false)
                        dispatch(
                            openPopup({
                                popupMessage: 'something went wrong',
                                popupType: 'error'
                            })
                        );
                    }
                } catch (error) {
                    setBannerLoading(false)
                    dispatch(
                        openPopup({
                            popupMessage: error?.message || 'something went wrong',
                            popupType: 'error'
                        })
                    );
                }
            }
        }
    }
    function handleSubmit(data: CreateProgramListFormValues) {
        const payload = {
            ...(loggedInUserType === 'User' ? { userId } : { companyId: userId })
        }
        Object.keys(data).forEach((key: string) => {
            if (typeof data[key] === 'string' && data[key] !== '') {
                payload[key] = data[key]
            } else if (typeof data[key] === 'object' && data[key]?.url !== '') {
                payload[key] = data[key]
            } else if (typeof data[key] === 'object' && (key === 'programType' || key === 'industry')) {
                payload[key] = data[key]
            }
        })
        dispatch(creatListProgram(payload)).then((res) => {
            if (res.status) {
                handleClose && handleClose()
            }
        })
    }
    return (
        <div className={cx.createProgramForm}>
            <h5 className={cx.programHeading}>List A Program</h5>
            <Formik
                initialValues={createProgramListFormInitialValue}
                validationSchema={createProgramListFormValidationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ errors, setFieldValue, touched, values }) => {
                    console.log(errors, 'errorsData');

                    return (
                        <Form noValidate className="create-edit-post-modal__content__form">
                            <div className='mb-1'>
                                <InputField
                                    id="programName"
                                    style={{ marginTop: '-4px' }}
                                    label="Program Name"
                                    placeholder="Program Name"
                                    errorMessage={errors.programName}
                                    isTouched={touched.programName}
                                    required
                                />
                            </div>
                            <div className='mb-1'>
                                <InputField
                                    id="organisationName"
                                    style={{ marginTop: '-4px' }}
                                    label="Organisation Name"
                                    placeholder="Organisation Name"
                                />
                            </div>
                            <div className='mb-1'>
                                <InputField
                                    id="link"
                                    style={{ marginTop: '-4px' }}
                                    label="Link"
                                    placeholder="Link"
                                    required
                                    errorMessage={errors.link}
                                    isTouched={touched.link}
                                />
                            </div>
                            <div className='mb-1'>
                                <InputField
                                    id="endDate"
                                    type='date'
                                    style={{ marginTop: '-4px' }}
                                    label="End Date"
                                    placeholder="End Date"
                                    min={disablePastDate()}
                                />
                            </div>
                            <div className='mb-1'>
                                <InputField
                                    id="description"
                                    style={{ marginTop: '-4px' }}
                                    label="Description"
                                    placeholder="Description"
                                />
                            </div>
                            <div className='mb-2'>
                                <MultiSelectField
                                    id="programType"
                                    variant={componentSizeVariantsEnum.SMALL}
                                    selectedValues={values.programType}
                                    onSelection={({ selectedValues }) => setFieldValue('programType', selectedValues)}
                                    options={programType}
                                    style={{ marginTop: '-4px' }}
                                    label="Program Type"
                                    placeholder="Program Type"
                                />
                            </div>
                            <div className='mb-1'>
                                <MultiSelectField
                                    id="industry"
                                    variant={componentSizeVariantsEnum.SMALL}
                                    selectedValues={values.industry}
                                    onSelection={({ selectedValues }) => setFieldValue('industry', selectedValues)}
                                    options={industriesOptions}
                                    style={{ marginTop: '-4px' }}
                                    label="Industry"
                                    placeholder="Industry"
                                />
                            </div>
                            <div>
                                <Card className="program-details__form__row__field mt-2">

                                    {!bannerLoading && !values?.banner?.url && <>
                                        <InputField
                                            label="Upload Program Banner - 277px (width) * 107px (height)"
                                            id='banner-label'
                                            hidden
                                            variant={componentSizeVariantsEnum.SMALL}
                                            placeholder="Upload Program Banner"
                                            type="text"
                                        />

                                        <div
                                            className="dynamic-field__upload-file"

                                        >
                                            <span className="dynamic-field__upload-file__drag-drop" onClick={openImageFileManager}>
                                                <UploadIcon />
                                                <input
                                                    type="file"
                                                    hidden
                                                    value={''}
                                                    ref={uploadImageRef}
                                                    accept=".jpg,.jpeg,.png,"
                                                    className="select-post-image"
                                                    onChange={(e) => {
                                                        handleUpload(e, setFieldValue)
                                                    }}
                                                />
                                            </span>
                                            <Typography
                                                as="span"
                                                variant="body-2"
                                                fontWeight="medium"
                                                className="dynamic-field__upload-file__browse"
                                                onClick={openImageFileManager}
                                            >
                                                Browse on your device
                                            </Typography>

                                        </div>
                                    </>}
                                    {bannerLoading && <Loader />}
                                    {values?.banner?.url && !bannerLoading && <Row>
                                        <Col md={12}>
                                            <div className='position-relative d-flex justify-content-center'>
                                                <button style={{ position: 'absolute', top: '10px', right: '10px', background: '#fff', height: '23px', fontSize: '14px', width: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', border: 'none', color: 'red' }} onClick={() => setFieldValue('banner', { url: '' })}>
                                                    X
                                                </button>
                                                <img src={values?.banner?.url} alt='banner' style={{ maxWidth: '277px', maxHeight: '107px', margin: "0 auto", objectFit: 'cover', backgroundPosition: 'center', marginTop: '10px', borderRadius: '10px' }} />
                                            </div>
                                        </Col>
                                    </Row>}
                                </Card>
                            </div>

                            <div className="create-edit-post-modal__content__buttons">
                                <Button
                                    variant="secondary"
                                    size="small"

                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="primary"
                                    size="small"
                                    type="submit"
                                    disabled={loading || bannerLoading}
                                >
                                    {loading ? <Loader /> : 'Submit'}
                                </Button>
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </div>
    )
}
